// This file is autogenerated from /frontend/sail-next/packages/docs/src/component-examples/ButtonGroup/Basic.story.tsx with go/sail-next-tailor-docs-publisher

import * as React from 'react';
import {Button, ButtonGroup} from '@sail/ui';
/* eslint-disable no-alert */

export const Basic = () => {
  return (
    <ButtonGroup>
      <Button
        onPress={() => {
          console.log('Filter');
        }}
      >
        Filter
      </Button>
      <Button
        onPress={() => {
          console.log('Export');
        }}
      >
        Export
      </Button>
      <Button
        type="primary"
        onPress={() => {
          console.log('Save');
        }}
      >
        Save
      </Button>
    </ButtonGroup>
  );
};
